import { render, staticRenderFns } from "./CheckoutSummarySeparator.vue?vue&type=template&id=47274d5c&functional=true&"
import script from "./CheckoutSummarySeparator.vue?vue&type=script&lang=js&"
export * from "./CheckoutSummarySeparator.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutSummarySeparator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports